import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setActiveTab,
  setPaginationPageNumber,
  TriggerFilterButtonApi,
} from "../../../../../slices/common/reducer";
import { setPspMappingFilterForm } from "../../../../../slices/team/users/usersSlice";
import { Button, Form } from "react-bootstrap";
import { Col, Row } from "reactstrap";
import Select from "react-select";
import Flatpickr from "react-flatpickr";
import {
  PSP_Mapping_FROM_DATE,
  PSP_Mapping_TO_DATE,
  PSP_TO_DATE,
} from "../../../../../Utils/FilterDateKeys";
import {
  filterDateOptions,
  handleFilterDateChange,
} from "../../../../../Utils/CommonUtils";

function PspFilter() {
  const dispatch = useDispatch();

  const filterForm = useSelector((state) => state.users.pspMappingFilter.form);

  const resetTabAndPageNumber = () => {
    dispatch(setPaginationPageNumber(0));
    dispatch(setActiveTab("ALL"));
  };

  const handleInputChange = (name, value) => {
    dispatch(setPspMappingFilterForm({ name, value }));
    resetTabAndPageNumber();
    dispatch(TriggerFilterButtonApi());
  };

  const handleClear = () => {
    dispatch(setPspMappingFilterForm({ type: "reset" }));

    dispatch(TriggerFilterButtonApi());

    if (Object.keys(filterForm).length > 0) {
      resetTabAndPageNumber();
    }
  };

  const userOptions = [
    { value: "LINKED", label: "Linked" },
    { value: "UNLINKED", label: "Unlinked" },
  ];

  return (
    <div className="filter-wrapper">
      <Form className="form-input">
        <Row>
          <Form.Group as={Col} className="col-md-4">
            <Form.Control
              type="text"
              placeholder="Search for Code..."
              name="code"
              id="code"
              value={filterForm.code || ""}
              onChange={(e) => handleInputChange(e.target.name, e.target.value)}
            />
          </Form.Group>
          <Form.Group as={Col} className="col-md-4">
            <Select
              isClearable
              placeholder="Status"
              name="linked_status"
              options={userOptions}
              value={
                userOptions?.find((itm) => itm.value === filterForm.linked_status) ||
                null
              }
              onChange={(e) => handleInputChange("linked_status", e ? e.value : "")}
            />
          </Form.Group>
          <Form.Group as={Col} className="col-md-3">
            <Flatpickr
              className="form-control border-lightgrey"
              placeholder="Select date"
              data-input
              options={filterDateOptions}
              value={[
                filterForm[PSP_Mapping_FROM_DATE]
                  ? new Date(filterForm[PSP_Mapping_FROM_DATE])
                  : null,
                filterForm[PSP_TO_DATE]
                  ? new Date(filterForm[PSP_TO_DATE])
                  : null,
              ]}
              onChange={(e) =>
                handleFilterDateChange(
                  e,
                  setPspMappingFilterForm,
                  PSP_Mapping_FROM_DATE,
                  PSP_Mapping_TO_DATE
                )
              }
            />
          </Form.Group>
          {/* <Form.Group as={Col} className="col-md-1">
            <div>
              <button type="button" className="btn btn-outline-primary">
                <i className="ri-equalizer-fill me-1 align-bottom"></i>
              </button>
            </div>
          </Form.Group> */}
          <Form.Group as={Col} className="col-md-1">
            <div>
              <Button className="primary-outline" onClick={handleClear}>
                Clear
              </Button>
            </div>
          </Form.Group>
        </Row>
      </Form>
    </div>
  );
}

export default PspFilter;
